var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"temp"},[_c('dv-capsule-chart',{staticClass:"temp",attrs:{"config":_vm.outPutConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }